import React, { FC } from 'react';
import { extractHighlightedWordsFromString } from '../../../components/highlight/extractHighlightedWordsFromString';

type Props = {
  children: string;
};

export const SearchAdviceHighlight: FC<Props> = ({ children }) => {
  const highlightedWords = extractHighlightedWordsFromString(children);

  return (
    <>
      {highlightedWords.map((item, index) =>
        item.highlighted ? (
          <b key={index} dangerouslySetInnerHTML={{ __html: item.value }} /> // eslint-disable-line react/no-array-index-key
        ) : (
          <span
            key={index} // eslint-disable-line react/no-array-index-key
            dangerouslySetInnerHTML={{ __html: item.value }}
          />
        ),
      )}
    </>
  );
};
